export default __webpack_public_path__ + "static/media/body.6610aa73.jpg";